export default (props, vars) => () =>
  vars?.['usestateactivetab']?.['setState']('past');
